import { useState, useEffect, useRef } from "react";
import {
  Button,
  ButtonGroup,
  Form,
  InputGroup,
  Table,
  ToggleButton,
} from "react-bootstrap";
// import check_example from "../../../assets/images/check_example.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import axios from "../../../axios";
import urls from "../../../Utils/urls";
import { useDispatch, useSelector } from "react-redux";
import {
  BlurWrapperWithSpan,
  LiHandleButton,
  SpinnerBlock,
} from "../../../Utils/CustomComponent";
import FormBox from "../../../components/FormBox/FormBox";
import { useAbortController } from "../../../hooks/useAbortController";
// import {
//   AchPaymentSchema,
//   AuthenticationSchema,
// } from "../../../Utils/formOptions";
import { toast } from "react-toastify";
import { commonToast, reduceSum } from "../../../Utils";
import moment from "moment";
import { LoadingButton } from "../../../Utils/CustomComponent";
import AuthenticationPopup from "./AuthenticationPopup";
import useBorowerLoanDetail, {
  transformLoanData,
} from "../../../hooks/useBorowerLoanDetail";
import { loadingTypes, oracleConfig } from "../../../Utils/constant";
import { RoutingNumberValidator } from "../Pages/ACHPayments/SameDayPayment";
// import classes from "../../../AllLoans/LoanDetails.module.css";
// import classes from "../../Borrowers/Pages/AllLoans/LoanDetails.module.css";
import CustomBreadCrumbs from "../../../components/CustomBreadCrumbs";
// import NewBankAccountACHPayment from "./NewBankAccountACHPayment";
// import useBankDetails from "../../../hooks/useBankDetails";
import useBorrowerDashboardTwo from "../BorrowerDashboardTwo/apis/useBorrowerDashboardTwo";
import PopupWrapper from "../../../components/PopupWrapper";
// import { setAchPayment } from "../../../store/reducers/achPaymentSlice";
import {
  fetchBorrowerAllAccountsLoanDetails,
  fetchBorrowerAllLoansBankDetails,
} from "../../../store/reducers/dashboardSlice/api";
import { ArrowLeft, PlusCircleFill } from "react-bootstrap-icons";
import NumberFormat from "react-number-format";
import useAchData from "./useAchData";
import { TaxInfoModal } from "../BorrowerDashboard/AchPopup";
import { ComingSoonWrapper } from "../BorrowerDashboardTwo/Payments";
import { useLoanForeClosureStatus } from "../../../hooks/useLoanMaturityStatus";
import { ForeClosureLoanModal } from "../BorrowerDashboardTwo/MaturedLoanModal";
import {
  BsCheckCircle,
  BsCheckCircleFill,
  BsChevronLeft,
  BsCreditCard2Back,
  BsPencilSquare,
  BsShieldCheck,
  BsSlashCircle,
  BsX,
  BsXCircle,
} from "react-icons/bs";
import styles from "./Redesigned.module.css";

// import classes from "../../Borrowers/pages/AllLoans/LoanDetails.module.css";

const BankAccountACHPayments = () => {
  // const [achInfo, setAchInfo] = useState(null);
  // const [achData, setAchData] = useState(null);
  // const [routingDetails, setRoutingDetails] = useState({});
  const [showPopup, setShowPopup] = useState(true);
  const [selectedOption, setSelectedOption] = useState("RP");
  // const [showBankInfo, setShowBankInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [viewBill, setViewBill] = useState(false);
  const [otpPopup, setOtpPopup] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState([]);
  // const [isRoutingNumberVerified, setIsRoutingNumberVerified] = useState(false);
  const [showRoutingNumberVaildatorPopup, setShowRoutingNumberVaildatorPopup] =
    useState(false);
  // const [loanDetailsAll, setLoanDetailsAll] = useState([]);
  const [iframeLoad, setIframeLoad] = useState(true);
  const [selectedLoanAccountId, setSelectedLoanAccountId] = useState(null);
  const [counter, setCounter] = useState(0);
  const [showTaxInfo, setShowTaxInfo] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showForeClosureModal, setShowForeClosureModal] = useState(false);
  const [foreClosureLoan, setForeClosureLoan] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const { signal } = useAbortController();
  const accountId = useSelector((state) => state.account.lenderId);
  // const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const paymentAccounts = useSelector(
    (state) => state.dashboard.borrowerAllLoansBankAccounts.data,
  );
  const optionStatus = useSelector(
    (state) => state.dashboard.borrowerAllLoansBankAccounts.status,
  );
  const sidebarVisibility = useSelector((state) => state.RS_Sidebar.show);
  const sidebarWidth = useSelector((state) => state.RS_Sidebar.sidebarWidth);
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  // const loanDetailsAll = useSelector(
  //   (state) => state.dashboard.borrowerAllAccountLoanDetails.data
  // );
  // const loanDetailsAllStatus = useSelector(
  //   (state) => state.dashboard.borrowerAllAccountLoanDetails.status
  // );
  const { loanDetails, status } = useBorowerLoanDetail(accountId);
  // const { bankDetails: paymentAccounts, status: optionStatus } =
  //   useBankDetails(accountId);
  const { activeAccountList: accountIdsData } = useBorrowerDashboardTwo();

  const location = useLocation();
  const [singleAccount, setSingleAccount] = useState(location?.state?.single);
  const [activeTab, setActiveTab] = useState(
    location?.state?.single
      ? null
      : location?.state?.activeTab
        ? location?.state?.activeTab
        : 0,
  );

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    control,
    setError,
    clearErrors,
  } = useForm();
  // } = useForm({ ...AchPaymentSchema });
  const { fields } = useFieldArray({
    control,
    name: "row",
  });

  const {
    achData,
    loading: loadingACH,
    getFilteredACHData,
    enrolledLoansCount,
    enrolledLoanData,
    secondLoader,
  } = useAchData(
    accountIdsData?.map((data) => data.value),
    activeTab,
    singleAccount,
    setValue,
    accountId,
    refresh,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const errorRef = useRef(null);

  const accountIds = singleAccount
    ? [accountId]
    : accountIdsData?.map((data) => data.value);

  const { loadingLoanStatus: foreClosureStatusLoader, foreClosureLoanData } =
    useLoanForeClosureStatus(accountIds);

  const totalAutopayAmount =
    enrolledLoanData?.reduce(
      (accumulator, el) =>
        accumulator + Math.round((el?.ACH_DEBIT_AMOUNT || 0) * 100),
      0,
    ) / 100;
  // const location = useLocation();
  const showAlert = loanDetails?.loanTerm?.achStatus
    ?.toLowerCase()
    ?.includes("you have a payment of");
  const dateStr = loanDetails?.loanTerm?.achStatus?.split("for")[1];
  // const scheduledDate = moment(new Date(dateStr)).format("MM/DD/YYYY");
  // const scheduledDateNew = moment().add(1, "days").format("MM/DD/YYYY");

  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const userId = localStorage.getItem("apex_userid");

  const loanOptionValue = watch("loanOption");
  const scheduledDateValue = watch("selectedDate");
  // const selectedReportLoanValue = watch("selectedReportLoan");
  const selectedPaymentDayLoan = watch("selectedPaymentDayLoan");
  const accountType = watch("accountType");
  const selectedBankAccountLoan = watch("selectedBankAccountLoan");

  const nextValidDate = selectedPaymentDayLoan
    ? getNextValidDate(selectedPaymentDayLoan)
    : null;

  const watchedFields = watch("row");
  const finalPayload = watchedFields
    ?.filter((el) => el.selectLoan)
    ?.map((item) => ({
      ...item,
      routingNumber: paymentAccounts?.data?.filter(
        (el) => el.NICK_NAME === selectedBankAccountLoan,
      )?.[0]?.routing_number,
      accountNumber: paymentAccounts?.data?.filter(
        (el) => el.NICK_NAME === selectedBankAccountLoan,
      )?.[0]?.account_number,
      achIndividualName: paymentAccounts?.data?.filter(
        (el) => el.NICK_NAME === selectedBankAccountLoan,
      )?.[0]?.ACH_INDIVIDUALNAME,
      bankAddress: paymentAccounts?.data?.filter(
        (el) => el?.NICK_NAME === selectedBankAccountLoan,
      )?.[0]?.ACH_BANKADDRESS,
      bankName: paymentAccounts?.data?.filter(
        (el) => el?.NICK_NAME === selectedBankAccountLoan,
      )?.[0]?.ACH_BANKNAME,
    }));
  // console.log({finalPayload})
  // console.log({selectedBankAccountLoan})
  // console.log(paymentAccounts?.data?.filter(
  //     (el) => el?.NICK_NAME === selectedBankAccountLoan,
  //   )?.[0], "condition")

  const resultArr = [
    {
      title: "Total Scheduled Payment",
      value: reduceSum(
        finalPayload?.map((data) => Number(data.achDebitAmount)),
      ),
      type: "amount",
    },
    {
      title: "Scheduled On",
      value: moment(scheduledDateValue).format("MM/DD/YYYY"),
    },
    // {
    //   title: "Payment Type",
    //   value: ACHPaymentTypeOptions.filter(
    //     (el) => el.value === selectedReportLoanValue
    //   )?.[0]?.label,
    // },
    {
      title: "Bank Account",
      value: paymentAccounts?.data?.filter(
        (el) => el.NICK_NAME === selectedBankAccountLoan,
      )?.[0]?.account_name,
    },
    {
      title: "Number of Loan Account(s) selected",
      value: finalPayload?.length,
    },
    {
      title: "Payment Type",
      value: "Regular Payment",
    },
    {
      title: "Frequency",
      value: "Monthly",
    },
  ];

  const routingNumber = watch("routingNumber");

  const paymentDays = [];

  for (let i = 1; i <= 28; i++) {
    paymentDays.push({ label: i.toString(), value: i.toString() });
  }

  useEffect(() => {
    if (!singleAccount && accountIdsData?.length) {
      getFilteredACHData();
    }
  }, [singleAccount, refresh, accountIdsData]);

  useEffect(() => {
    register("accounts");
  }, [register]);

  useEffect(() => {
    if (errors?.accounts?.message && errorRef.current) {
      errorRef.current.focus();
    }
  }, [errors?.accounts?.message]);

  useEffect(() => {
    achData?.forEach((el, idx) => {
      setValue(`row[${idx}].selectLoan`, false);
    });
  }, [activeTab, setValue]);

  useEffect(() => {
    if (location?.state?.single) {
      setSingleAccount(location?.state?.single);
    }
  }, [location.state]);

  useEffect(() => {
    if (counter) {
      // dispatch(fetchBorrowerAllAccountsLoanDetails({ accountIds, signal }));
      dispatch(
        fetchBorrowerAllLoansBankDetails({
          requestBody: {
            RecID: accountIds.join(","),
          },
          userId,
          signal,
        }),
      );
    }
  }, [accountId, counter, dispatch]);

  useEffect(() => {
    if (selectedOption == null) {
      setShowPopup(true);
    }
  }, [selectedOption, showPopup]);

  useEffect(() => {
    if (accountIds?.length && !counter) {
      setCounter((prev) => prev + 1);
      // dispatch(fetchBorrowerAllAccountsLoanDetails({ accountIds, signal }));
    }
  }, [
    accountIds?.length,
    // loanDetailsAllStatus,
    dispatch,
    singleAccount,
    counter,
    accountId,
  ]);

  useEffect(() => {
    if (accountIds?.length && !counter) {
      setCounter((prev) => prev + 1);
      dispatch(
        fetchBorrowerAllLoansBankDetails({
          requestBody: {
            RecID: accountIds.join(","),
          },
          userId,
          signal,
        }),
      );
    }
  }, [
    accountIds?.length,
    dispatch,
    optionStatus,
    singleAccount,
    counter,
    accountId,
  ]);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     onSubmit(data);
  //   }
  // }, [isAuthenticated]);

  const handleAuthentication = (data) => {
    // setData(data);
    if (!finalPayload?.length) {
      setError("accounts", {
        type: "custom",
        message: "**You have not selected any loan account for payment!",
      });
    } else if (!paymentAccounts?.options?.length) {
      setError("selectedBankAccountLoan", {
        type: "custom",
        message:
          "**No bank account selected. If you don’t have one, click the “Add New Bank Account” link to create one.",
      });
    } else if (finalPayload?.length && paymentAccounts?.options?.length) {
      clearErrors("accounts");
      setData(finalPayload);
      // setOtpPopup(true);
      onSubmit(finalPayload);
    }
  };

  async function onSubmit(data) {
    // if (!isAuthenticated) return;

    setLoading(true);
    setDisabled(true);
    const id = toast.loading("Processing your request...");

    const finalData = finalPayload.map((el) => ({
      loanID: el.loanNumber,
      ACH_RoutingNumber: el.routingNumber,
      ACH_AccountType: accountType,
      ACH_AccountNumber: el.accountNumber,
      // ACH_Frequency: Number(el.selectedReportLoan),
      ACH_Frequency: 1,
      ACH_DebitAmount: el.achDebitAmount,
      // ACH_ServiceStatus: Number(el.scheduledPaymentStatus),
      ACH_ServiceStatus: 1,
      ACH_StopDate: el?.achStopDate
        ? moment(el.achStopDate).format("MM/DD/YYYY")
        : null,
      ACH_DebitDueDay: Number(selectedPaymentDayLoan),
      // ACH_NextPaymentDate: moment(el.selectedDate).format("MM/DD/YYYY"),
      ACH_NextPaymentDate: moment(scheduledDateValue).format("MM/DD/YYYY"),
      ACH_IndividualName: el.ACH_IndividualName,
      // email: achInfo.emailaddress,
      email: userDetails?.email,
      // early_payment_type: el.loanOption,
      early_payment_type: "RP",
      early_payment_note: "",
      ACH_BankName: el?.bankName,
      ACH_BankAddress: el?.bankAddress,
    }));

    try {
      const res = await axios.post(
        // urls.borrower.postPaymentsLoanAchInfo,
        urls.borrower.postPaymentsLoanAchInfoUAT,
        finalData,
        // {
        //   loanID: localStorage.getItem("borrowerLoanId"),
        //   ACH_RoutingNumber: data.routingNumber,
        //   ACH_AccountType: data.verifyAccountNumber,
        //   ACH_AccountNumber: data.accountNumber,
        //   ACH_Frequency: Number(data.selectedReport),
        //   ACH_DebitAmount: data.achDebitAmount,
        //   ACH_ServiceStatus: Number(data.scheduledPaymentStatus),
        //   ACH_StopDate: moment(achInfo.ACH_StopDate).format("MM/DD/YYYY"),
        //   ACH_DebitDueDay: Number(data.selectedPaymentDay),
        //   ACH_NextPaymentDate: moment(data.selectedDate).format("MM/DD/YYYY"),
        //   ACH_IndividualName: data.bankAccountName,
        //   // email: achInfo.emailaddress,
        //   email: userDetails?.email,
        //   early_payment_type: selectedOption || "RP",
        //   early_payment_note: "",
        //   isRoutingNumberVerified: isRoutingNumberVerified,
        // },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        },
      );

      const finalDataForSQL = finalPayload.map((el) => ({
      loanID: el.loanNumber,
      ACH_RoutingNumber: el.routingNumber,
      ACH_AccountType: accountType,
      ACH_AccountNumber: el.accountNumber,
      // ACH_Frequency: Number(el.selectedReportLoan),
      ACH_Frequency: 1,
      ACH_DebitAmount: el.achDebitAmount,
      // ACH_ServiceStatus: Number(el.scheduledPaymentStatus),
      ACH_ServiceStatus: 1,
      ACH_StopDate: moment(el.achStopDate).format("MM/DD/YYYY"),
      ACH_DebitDueDay: Number(selectedPaymentDayLoan),
      // ACH_NextPaymentDate: moment(el.selectedDate).format("MM/DD/YYYY"),
      ACH_NextPaymentDate: moment(scheduledDateValue).format("MM/DD/YYYY"),
      ACH_IndividualName: el.ACH_IndividualName,
      // email: achInfo.emailaddress,
      email: userDetails?.email,
      // early_payment_type: el.loanOption,
      early_payment_type: "RP",
      early_payment_note: "",
      ACH_BankName: el?.bankName,
      ACH_BankAddress: el?.bankAddress,
      currentuser_info:
          masqueradeEmail?.isIt == true
            ? masqueradeEmail?.p_logged_in_email
            : email,
    }));

      if (res?.status == 200) {
        const res2 = await axios.post(
          urls.borrower.postPaymentsLoanAchInfoV2,
          finalDataForSQL,
        );
      }
      toast.update(id, {
        render: res?.data?.[0]?.[1]?.status || "Success",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      setLoading(false);
      setDisabled(false);
      navigate("/borrower-dashboard-two");
    } catch (error) {
      setLoading(false);
      setDisabled(false);
      toast.update(id, {
        render: "Upload Failed",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    }
  }

  function checkMaturity(loan, index) {
    const isForeclosureLoan = foreClosureLoanData?.filter(
      (el) => el?.Account === loan.account && el?.Flag == "Y",
    );

    if (isForeclosureLoan?.length) {
      setShowForeClosureModal(true);
      setForeClosureLoan(isForeclosureLoan[0]);
    } else {
      setShowForeClosureModal(false);
      setForeClosureLoan(null);
    }
  }

  const renderFormBox = (fieldProps) => (
    <FormBox
      options={[fieldProps]}
      register={register}
      watch={watch}
      setValue={setValue}
      errors={errors}
    />
  );

  const getDayWithSuffix = (day) => {
    const num = Number(day);

    if (num >= 11 && num <= 13) {
      return `${num}th`;
    }

    switch (num % 10) {
      case 1:
        return `${num}st`;
      case 2:
        return `${num}nd`;
      case 3:
        return `${num}rd`;
      default:
        return `${num}th`;
    }
  };

  function handleClear() {
    finalPayload?.forEach((el) => {
      setValue(`row[${el.selectedIndex}].selectLoan`, false);
    });
  }

  return (
    <div>
      <section className={styles.container}>
        {/* Breadscrumb Below */}
        {/* <div className="py-3 pb-0  mt-1">
          <CustomBreadCrumbs
            crumbs={[
              { title: "Dashboard", link: "/borrower-dashboard-two" },
              { title: "Setup Autopay" },
            ]}
          />
        </div> */}

        <div className="mb-4 text-secondary small">
          <span
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
            className="linkClick"
          >
            <BsChevronLeft className="me-1" /> Back{" "}
          </span>
          <span className="mx-2">|</span> Recurring ACH Autopay
        </div>

        <div className={`${styles.headerCard} mb-5`}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex flex-column align-items-start">
              <span className={styles.badge}>Recurring ACH</span>
              <h1 className="fw-bold mt-3 mb-2">
                Manage autopay across your loans
              </h1>
              <p className="text-secondary">
                Activate or pause autopay per loan. To change a bank account,
                payment day or account type, select loans and update them
                together.
              </p>
            </div>

            <div className="d-flex border p-4 rounded-3">
              {!secondLoader ? (
                <div className="d-flex justify-content-end">
                  <div className="px-4 text-center">
                    <div className="text-muted small fw-bold mb-1">
                      SCHEDULED LOANS
                    </div>
                    <div className={styles.statValue}>
                      {enrolledLoansCount} / {accountIdsData?.length}
                    </div>
                  </div>
                  {!singleAccount && (
                    <div className={`${styles.statBox} ps-5`}>
                      <div className="text-muted small fw-bold mb-1 pe-3">
                        MONTHLY TOTAL
                      </div>
                      <div
                        className={`${styles.statValue} ${styles.priceValue}`}
                      >
                        ${totalAutopayAmount.toFixed(2)}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <SpinnerBlock height="10vh" />
              )}
            </div>
          </div>
        </div>

        {status === loadingTypes.fulfilled &&
        optionStatus === loadingTypes.fulfilled ? (
          // &&
          // loanDetailsAllStatus === loadingTypes.fulfilled
          <div
          // className="p-3 pb-0  mt-1"
          >
            <div>
              {!achData || foreClosureStatusLoader ? (
                <h4 className="my-5">
                  Ach Payments
                  <SpinnerBlock height="50vh" />
                </h4>
              ) : (
                <>
                  <div
                    // className="p-3 pb-0  mt-1"
                    style={{ textAlign: "start" }}
                  >
                    {/* <h4 className="my-5">Bank Account ACH Payments</h4> */}
                    {/* <h4 className="my-5">Monthly Recurring Payment Schedule</h4> */}
                    <div
                      // style={{
                      //   borderRadius: "8px",
                      //   paddingTop: "15px",
                      //   margin: "20px 4px",
                      //   background: "#fff",
                      // }}
                      className="row"
                    >
                      <div>
                        {/* <p>
                          Set up or update ACH Information to automatically make
                          your loan payments. Save time. Save money. Avoid late
                          fees. 0%
                        </p> */}

                        <div className="d-flex justify-content-between align-items-center mb-5">
                          <ul
                            className={`nav nav-pills ${styles.tabs} bg-grey py-3 px-5 rounded-pill`}
                          >
                            {!singleAccount &&
                              tabButtons.map((type, idx) => (
                                <li className="nav-item" key={type.key}>
                                  <button
                                    className={`${styles.tabLink} ${activeTab === idx ? styles.tabActive : ""} nav-link`}
                                    onClick={() => setActiveTab(idx)}
                                  >
                                    {type.title}
                                  </button>
                                </li>
                              ))}
                          </ul>
                        </div>
                        {/* <NewBankAccountACHPayment /> */}
                        {/* {!singleAccount && (
                          <ul className="nav nav-tabs my-5">
                            {tabButtons.map((data, index) => (
                              <LiHandleButton
                                key={index}
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                label={data.label}
                                value={index}
                                handleBtnClick={setActiveTab}
                              />
                            ))}
                          </ul>
                        )} */}

                        <div
                          style={{
                            height: !singleAccount
                              ? achData?.length > 5
                                ? "600px"
                                : "auto"
                              : "", // Fixed height for scrollable container
                            overflowY: "auto", // Enables vertical scrolling
                            overflowX: "auto", // Enables horizontal scrolling
                            position: "relative", // Required for sticky positioning }}>
                          }}
                        >
                          {!loadingACH ? (
                            <div className={styles.tableContainer}>
                              <table className={`table mb-0 ${styles.table}`}>
                                <thead
                                  // className="text-center bg-primary text-white"
                                  style={{
                                    //   position: "sticky",
                                    //   top: 0, // Keeps the header at the top of the container while scrolling vertically
                                    //   backgroundColor: "white", // White background to avoid transparency
                                    //   zIndex: 10, // Ensures it stays above other rows while scrolling
                                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // Adds a shadow for visibility
                                  }}
                                >
                                  <tr>
                                    <th></th>
                                    <th>LOAN</th>
                                    <th>BANK ACCOUNT</th>
                                    <th colSpan={2}>Property Address</th>
                                    {/* <th>Option</th> */}
                                    {/* <th>Select Payment Day</th> */}
                                    {/* <th>Frequency</th> */}
                                    {/* <th>ACH Debit Amount</th> */}
                                    {(tabButtons[activeTab]?.title ===
                                      "Scheduled Loans" ||
                                      (singleAccount &&
                                        achData?.[0]?.ACH_ServiceStatus ==
                                          1)) && (
                                      <>
                                        {/* <th>Debit Due Day</th>
                                        <th>Next Due Date</th> */}
                                        <th>PAYMENT DAY</th>
                                      </>
                                    )}
                                    <th>ACH AMOUNT</th>
                                    <th>STATUS</th>
                                    <th className="text-end">ACTIONS</th>
                                    {/* <th>View Bills</th> */}
                                    {/* 
                                    <th>Scheduled Payment Status *</th>
                                    <th style={{ width: "10%" }}>
                                      Scheduled Payment Date
                                    </th>
                                    <th>Debit From</th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {achData?.length ? (
                                    achData.map((data, index) => {
                                      const isBankAssociated =
                                        data?.ACH_ACCOUNTNUMBER === "" ||
                                        data?.ACH_AccountNumber === "";

                                      const filteredForeClosureLoan =
                                        foreClosureLoanData?.filter(
                                          (loan) =>
                                            loan?.Account == data?.account,
                                        );

                                      const isForeClosureLoan =
                                        filteredForeClosureLoan?.length
                                          ? filteredForeClosureLoan[0]?.Flag ===
                                            "Y"
                                          : false;

                                      return (
                                        <tr
                                          key={
                                            data?.account ??
                                            data?.loan_account_number
                                          }
                                          className={
                                            finalPayload?.some(
                                              (el) =>
                                                el?.selectedIndex == index,
                                            )
                                              ? styles.rowSelected
                                              : ""
                                          }
                                        >
                                          <td
                                            onClick={() =>
                                              checkMaturity(data, index)
                                            }
                                          >
                                            {
                                              // data?.DISABLE_YN &&
                                              // data?.DISABLE_YN === "N" ? (
                                              renderFormBox({
                                                title: "",
                                                field: `row[${index}].selectLoan`,
                                                type: "checkbox",
                                                className: "col-12",
                                                defaultValue: isForeClosureLoan
                                                  ? false
                                                  : singleAccount
                                                    ? true
                                                    : null,
                                                disable: isForeClosureLoan
                                                  ? true
                                                  : singleAccount
                                                    ? true
                                                    : false,
                                                customStyle: {
                                                  borderRadius: "50%",
                                                  width: "20px",
                                                  height: "20px",
                                                  borderColor:
                                                    "var(--primary-color)",
                                                  borderWidth: "2px",
                                                },
                                              })
                                              // ) : data?.DISABLE_YN &&
                                              //   data?.DISABLE_YN === "Y" ? (
                                              //   <button
                                              //     className="btn btn-error text-white p-1"
                                              //     onClick={() => {
                                              //       setShowTaxInfo(true);
                                              //       if (data?.recid) {
                                              //         setSelectedLoanAccountId(
                                              //           data.recid
                                              //         );
                                              //       }
                                              //     }}
                                              //   >
                                              //     Submit Tax Info
                                              //   </button>
                                              // ) : (
                                              // renderFormBox({
                                              //   title: "",
                                              //   field: `row[${index}].selectLoan`,
                                              //   type: "checkbox",
                                              //   className: "col-12",
                                              //   defaultValue: singleAccount
                                              //     ? true
                                              //     : null,
                                              //   disable: singleAccount
                                              //     ? true
                                              //     : false,
                                              // })
                                              // )
                                            }
                                          </td>
                                          <td>
                                            <BlurWrapperWithSpan>
                                              {/* {data?.loan_account_number} -{" "}
                                              {data?.ACH_IndividualName} */}
                                              <div className="fw-bold">
                                                {
                                                  watchedFields[
                                                    index
                                                  ]?.loan_account?.split(
                                                    " - ",
                                                  )?.[0]
                                                }
                                              </div>
                                              <div className="text-muted small">
                                                {
                                                  watchedFields[
                                                    index
                                                  ]?.loan_account?.split(
                                                    " - ",
                                                  )?.[1]
                                                }
                                              </div>
                                            </BlurWrapperWithSpan>
                                          </td>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <BsCreditCard2Back className="me-4" />
                                              <div>
                                                <div className="">
                                                  {data?.ACH_ACCOUNTNUMBER
                                                    ? "*".repeat(
                                                        data?.ACH_ACCOUNTNUMBER
                                                          ?.length - 4,
                                                      ) +
                                                      data?.ACH_ACCOUNTNUMBER?.slice(
                                                        -4,
                                                      )
                                                    : data?.ACH_AccountNumber
                                                      ? "*".repeat(
                                                          data
                                                            ?.ACH_AccountNumber
                                                            ?.length - 4,
                                                        ) +
                                                        data?.ACH_AccountNumber?.slice(
                                                          -4,
                                                        )
                                                      : "-"}
                                                </div>
                                                {/* <div className="text-muted small">{loan.type}</div> */}
                                              </div>
                                            </div>
                                          </td>
                                          <td colSpan={2} className="small">
                                            <BlurWrapperWithSpan>
                                              {data?.STREET
                                                ? `${data.STREET} - ${data.CITY}, ${data.STATE} ${data.ZIPCODE}`
                                                : singleAccount &&
                                                  loanDetails?.loanTerm?.loanheader2?.split(
                                                    ":",
                                                  )?.[1]}
                                            </BlurWrapperWithSpan>
                                          </td>

                                          {(tabButtons[activeTab]?.title ===
                                            "Scheduled Loans" ||
                                            (singleAccount &&
                                              achData?.[0]?.ACH_ServiceStatus ==
                                                1)) && (
                                            <>
                                              {/* <td>
                                                {data?.ACH_DEBIT_DUEDAY ||
                                                  data?.ACH_DebitDueDay}
                                              </td> */}
                                              <td>
                                                <div className="fw-bold small">
                                                  {getDayWithSuffix(
                                                    data?.ACH_DEBIT_DUEDAY ||
                                                      data?.ACH_DebitDueDay,
                                                  )}{" "}
                                                  of month
                                                </div>
                                                <div className="text-muted small">
                                                  Next:{" "}
                                                  {data?.NextDueDate
                                                    ? moment(
                                                        data?.NextDueDate,
                                                      )?.format("MM/DD/YYYY")
                                                    : moment(
                                                        data?.NEXTDUEDATE,
                                                      )?.format("MM/DD/YYYY")}
                                                </div>
                                              </td>
                                            </>
                                          )}
                                          <td>
                                            <InputGroup
                                              className="fw-bold"
                                              // style={{ minHeight: "50px" }}
                                            >
                                              {/* <InputGroup.Text>
                                                $
                                              </InputGroup.Text> */}
                                              {/* <Form.Control
                                                type="number"
                                                placeholder="Price"
                                                step="0.01"
                                                {...register(
                                                  `row[${index}].achDebitAmount`,
                                                  {
                                                    required:
                                                      "Amount is required",
                                                    valueAsNumber: true,
                                                    validate: (value) => {
                                                      if (value < 0) {
                                                        return "Must be a positive number";
                                                      } else if (
                                                        value > 500000
                                                      ) {
                                                        return "The debit amount must not be more than $500000";
                                                      }
                                                      return true;
                                                    },
                                                  }
                                                )}
                                                onBlur={(e) => {
                                                  const val = parseFloat(
                                                    e.target.value
                                                  );
                                                  if (!isNaN(val)) {
                                                    e.target.value =
                                                      val.toFixed(2);
                                                  }
                                                }}
                                                defaultValue={data?.ACH_DEBIT_AMOUNT?.toFixed(
                                                  2
                                                )}
                                              /> */}
                                              <Controller
                                                name={`row[${index}].achDebitAmount`}
                                                control={control}
                                                render={({
                                                  field: {
                                                    onChange,
                                                    value,
                                                    ref,
                                                  },
                                                }) => (
                                                  <NumberFormat
                                                    displayType="text"
                                                    value={value}
                                                    prefix={"$"}
                                                    customInput={false}
                                                    fixedDecimalScale={true}
                                                    decimalScale={2}
                                                    thousandSeparator={true}
                                                  />
                                                )}
                                              />
                                            </InputGroup>
                                            {errors.row?.[index]
                                              ?.achDebitAmount && (
                                              <p className="text-error">
                                                {
                                                  errors.row[index]
                                                    .achDebitAmount.message
                                                }
                                              </p>
                                            )}
                                          </td>

                                          <td>
                                            <span
                                              className={
                                                tabButtons[activeTab]?.title ===
                                                  "Scheduled Loans" ||
                                                (singleAccount &&
                                                  achData?.[0]
                                                    ?.ACH_ServiceStatus == 1)
                                                  ? styles.statusActive
                                                  : styles.statusInactive
                                              }
                                            >
                                              {(tabButtons[activeTab]?.title ===
                                                "Scheduled Loans" ||
                                                (singleAccount &&
                                                  achData?.[0]
                                                    ?.ACH_ServiceStatus ==
                                                    1)) && (
                                                <BsCheckCircleFill
                                                  size={10}
                                                  className="me-1"
                                                />
                                              )}
                                              {tabButtons[activeTab]?.title ===
                                                "Scheduled Loans" ||
                                              (singleAccount &&
                                                achData?.[0]
                                                  ?.ACH_ServiceStatus == 1)
                                                ? "Active"
                                                : "Inactive"}
                                            </span>
                                          </td>

                                          <td className="text-end">
                                            {/* <ButtonGroup className=""> */}
                                            <ActionComp
                                              defaultVal={
                                                tabButtons[activeTab]?.title ===
                                                  "Scheduled Loans" ||
                                                (singleAccount &&
                                                  achData?.[0]
                                                    ?.ACH_ServiceStatus == 1)
                                                  ? "Active"
                                                  : "Inactive"
                                              }
                                              key1={
                                                data?.account
                                                  ? data.account
                                                  : data.loan_account_number
                                              }
                                              loan={data}
                                              singleAccount={singleAccount}
                                              setRefresh={setRefresh}
                                              refresh={refresh}
                                              disabled={
                                                isForeClosureLoan ||
                                                isBankAssociated
                                              }
                                              noBankAssociated={
                                                isBankAssociated
                                              }
                                            />
                                            {/* </ButtonGroup> */}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={8}
                                        style={{
                                          textAlign: "center",
                                          padding: "16px",
                                        }}
                                      >
                                        {"No " + tabButtons[activeTab]?.title}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                              <PopupWrapper
                                title=""
                                extraClass="width-800"
                                toShow={viewBill}
                                closeEventHandler={() => {
                                  setViewBill(false);
                                  setIframeLoad(true);
                                }}
                                Component={
                                  <div
                                    className="d-flex mt-3 justify-content-center align-items-center border p-3"
                                    style={{ maxWidth: "1000px" }}
                                  >
                                    {iframeLoad && (
                                      <SpinnerBlock height="40vh" />
                                    )}
                                    <BlurWrapperWithSpan>
                                      <iframe
                                        src={`https://servicing.loans/billing-attachments/${selectedLoanAccountId}`}
                                        height="400"
                                        width="618"
                                        title="bill"
                                        onLoad={() => setIframeLoad(false)}
                                      />
                                    </BlurWrapperWithSpan>
                                  </div>
                                }
                              />
                            </div>
                          ) : (
                            <div>
                              <SpinnerBlock height="10vh" />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="ms-2 mt-4">
                        <div className={`${styles.infoBanner}`}>
                          <div className={styles.infoIcon}>!</div>

                          <div className={styles.infoText}>
                            <span className={styles.infoTitle}>Heads up</span> ·
                            If the scheduled date falls on a weekend or public
                            holiday, the debit will occur on the next business
                            day. Please allow 1–2 business days to see your
                            payment posted to your account.
                          </div>
                        </div>
                      </div>

                      {/* {achData?.length ? (
                        <div className="mb-5">
                          <Form.Label className="mt-5 fw-bold">
                            Permanency
                          </Form.Label>
                          <div className="row">
                            <FormBox
                              options={optionsArr(
                                loanOptionValue,
                                paymentAccounts,
                                nextValidDate,
                              )}
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              errors={errors}
                            />
                          </div>
                          <div className="text-decoration-none text-primary pe-5 d-flex align-items-center justify-content-end mb-5">
                            <div
                              className="d-flex align-items-center gap-3"
                              role="button"
                              onClick={() => navigate("/add-bank-account")}
                            >
                              <div>
                                <PlusCircleFill
                                  style={{ color: "var(--primary-color)" }}
                                />
                              </div>
                              <div>Add New Bank Account</div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="mb-5" />
                      )}

                      {finalPayload?.length ? (
                        <div>
                          <Form.Label className="mt-5 fw-bold">
                            Summary
                          </Form.Label>
                          <div
                            className="alert alert-secondary p-5 mx-3 border"
                            role="alert"
                          >
                            <Table
                              bordered
                              size="lg"
                              style={{ fontSize: "16px" }}
                            >
                              <tbody>
                                {resultArr.map((item) => (
                                  <tr key={item.title}>
                                    <th
                                      style={{
                                        background: "rgb(251, 251, 251)",
                                      }}
                                      className="text-primary"
                                    >
                                      {item.title}
                                    </th>
                                    <td className="text-muted">
                                      {item?.type === "amount" ? (
                                        <NumberFormat
                                          displayType="text"
                                          value={item.value}
                                          prefix={"$"}
                                          fixedDecimalScale={true}
                                          decimalScale={2}
                                          thousandSeparator={true}
                                        />
                                      ) : (
                                        item.value
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      ) : null} */}

                      {/* <div>
                        <div
                          className="alert alert-primary p-5 mx-3"
                          role="alert"
                        >
                          <h6 className="fw-bold"> Disclaimer</h6>
                          <p>
                            If the scheduled date falls on a weekend or public
                            holiday, the debit will occur on the next business
                            day. Please allow 1–2 business days to see your
                            payment posted to your account.
                          </p>
                        </div>
                      </div> */}

                      {/* <div>
                        <Form.Label className="mt-5 fw-bold">
                          Authorization *
                        </Form.Label>
                        <p>
                          I hereby authorize Superior Loan Servicing to debit my
                          account. If the above noted payment dates fall on a
                          weekend or holiday, I understand that the payments may
                          be executed on the next business day. I understand
                          that recurring monthly payments will be debited for
                          the amount billed each month or the payment due each
                          month including any unpaid charges and/or late
                          charges. For ACH debits from my checking/savings
                          account, I understand that because these are
                          electronic transactions, these funds may be withdrawn
                          from my account as soon as the date entered above. In
                          the case of an ACH Transaction being rejected for
                          Non-Sufficient Funds (NSF) I understand that Superior
                          Loan Servicing may at its discretion attempt to
                          process the charge again within 30 days, and agree to
                          an additional $45 charge for each attempt returned NSF
                          which will be initiated as a separate transaction from
                          the authorized recurring payment. I acknowledge that
                          the origination of ACH transactions from my account
                          must comply with the provisions of U.S. law. I certify
                          that I am an authorized user of this bank account and
                          will not dispute these scheduled transactions with my
                          bank; so long as the transactions correspond to the
                          terms indicated in this authorization. All ACH
                          payments post on the next business day following the
                          date they are scheduled. All payments are considered
                          received on the date of posting and not the date they
                          are scheduled. Payments that are scheduled on the last
                          day of a grace period will not post until the
                          following business day and the account may be subject
                          to a late charge.
                        </p>
                        <Form.Label className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            className="m-3"
                            {...register("authorization", {
                              required: "Authorization must be true",
                            })}
                          />
                          Yes
                        </Form.Label>
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors?.authorization?.message}
                        </div>
                      </div> */}
                      {/* <div>
                        <LoadingButton
                          loading={loading}
                          disabled={disabled || !achData?.length}
                          type="submit"
                          className="btn btn-primary text-white"
                          title={"Submit"}
                          onClick={handleSubmit(handleAuthentication)}
                        />
                      </div>
                      <div
                        className="invalid-feedback fs-4"
                        style={{ display: "block" }}
                        ref={errorRef}
                        tabIndex={-1}
                        aria-live="assertive"
                      >
                        {errors?.accounts?.message}
                      </div> */}
                    </div>
                  </div>

                  {finalPayload?.length > 0 && (
                    <div
                      className={styles.footerActions}
                      style={{
                        marginLeft: sidebarVisibility
                          ? "calc(" + sidebarWidth + ")"
                          : "0px",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <span className="badge bg-danger rounded-pill px-4 py-3 me-3">
                          {finalPayload.length} selected
                        </span>
                        <span className="text-muted small">
                          Update bank account, payment day or account type for
                          the selected loans.
                        </span>
                      </div>
                      <div>
                        <button
                          className="btn btn-link text-secondary text-decoration-none me-4"
                          onClick={handleClear}
                        >
                          Clear
                        </button>
                        <button
                          className={`btn btn-primary ${styles.btnUpdate}`}
                          type="button"
                          onClick={() => setShowUpdateModal(true)}
                        >
                          <BsPencilSquare className="me-2" /> Update selected
                        </button>
                      </div>

                      <UpdateLoansModal
                        show={showUpdateModal}
                        onHide={() => setShowUpdateModal(false)}
                        selectedLoans={finalPayload}
                        loanOptionValue={loanOptionValue}
                        paymentAccounts={paymentAccounts}
                        nextValidDate={nextValidDate}
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        errors={errors}
                        SubmitButton={
                          <LoadingButton
                            loading={loading}
                            disabled={disabled || !achData?.length}
                            type="submit"
                            className="btn btn-primary text-white btn-modern-outline"
                            title={
                              <>
                                <BsShieldCheck className="me-2" /> Submit
                                changes
                              </>
                            }
                            onClick={handleSubmit(handleAuthentication)}
                          />
                        }
                        errorCode={
                          <div
                            className="invalid-feedback fs-4"
                            style={{ display: "block" }}
                            ref={errorRef}
                            tabIndex={-1}
                            aria-live="assertive"
                          >
                            {errors?.accounts?.message}
                          </div>
                        }
                        laonStatus={
                          tabButtons[activeTab]?.title === "Scheduled Loans" ||
                          (singleAccount &&
                            achData?.[0]?.ACH_ServiceStatus == 1)
                            ? "Active"
                            : "Inactive"
                        }
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ) : status === loadingTypes.loading ||
          optionStatus === loadingTypes.loading ? (
          // ||
          // loanDetailsAllStatus === loadingTypes.loading
          <div style={{ paddingTop: "8rem" }}>
            <SpinnerBlock height="50vh" />
          </div>
        ) : status === loadingTypes.error ||
          optionStatus === loadingTypes.failed ? (
          <div
            className="bg-white text-center text-error"
            style={{ height: "10vh" }}
          >
            Some error occured
          </div>
        ) : null}
      </section>
      <AuthenticationPopup
        otpPopup={otpPopup}
        setOtpPopup={setOtpPopup}
        // user={JSON.parse(user)}
        setIsAuthenticated={setIsAuthenticated}
      />

      <RoutingNumberValidator
        show={showRoutingNumberVaildatorPopup}
        setShow={setShowRoutingNumberVaildatorPopup}
        clearErrors={clearErrors}
        setDisableBtn={setDisabled}
        routingNumber={routingNumber}
      />
      <TaxInfoModal
        show={showTaxInfo}
        setShow={setShowTaxInfo}
        loanRecId={selectedLoanAccountId}
      />
      <ForeClosureLoanModal
        show={showForeClosureModal}
        onClose={() => setShowForeClosureModal(false)}
        showClose={true}
        maturityDate={foreClosureLoan?.MaturityDate}
        foreclosureLoan={foreClosureLoan?.Account}
        loanRecid={foreClosureLoan?.RecID}
        isRoc={foreClosureLoan?.databasename === "ROC"}
      />
      <style>
        {`
          td {
          vertical-align: middle;
          }
        `}
      </style>
    </div>
  );
};

export default BankAccountACHPayments;

const options = [
  { label: "Regular Payment", value: "RP" },
  // { label: "Principal Pay Down", value: "PP" },
  // { label: "Other Fees and Charges", value: "OF" },
];

const ACHPaymentTypeOptions = [{ label: "Monthly", value: "1" }];

const aCHDebitDueDayOptions = Array.from({ length: 28 }, (_, i) => ({
  label: `${i + 1}`,
  value: `${i + 1}`,
}));

const AccountTypeOptions = [
  { label: "Checking", value: "0" },
  { label: "Savings", value: "1" },
];

const optionsArr = (loanOptionValue, paymentAccounts, nextValidDate) => {
  return [
    // {
    //   title: "Payment Type",
    //   field: "loanOption",
    //   type: "select",
    //   options: options,
    //   defaultValue: "RP",
    //   className: "col-6",
    // },
    {
      title: "Select Payment Day Loan",
      field: `selectedPaymentDayLoan`,
      type: "select",
      options: aCHDebitDueDayOptions,
      defaultValue: "1",
      className: "col-6",
    },
    // {
    //   title: "Frequency",
    //   field: "selectedReportLoan",
    //   type: "select",
    //   options: ACHPaymentTypeOptions,
    //   defaultValue: "1",
    //   className: "col-6",
    // },
    {
      title: "Schedule Date",
      field: `selectedDate`,
      type: "date",
      // minDate: new Date(moment().add(1, "days")),
      value: nextValidDate ? nextValidDate : null,
      className: "col-6",
      filter: true,
      disable: true,
    },
    {
      title: "Account Type",
      field: "accountType",
      type: "select",
      options: AccountTypeOptions,
      defaultValue: "0",
      className: "col-6",
    },
    {
      title: "Bank Account",
      field: `selectedBankAccountLoan`,
      type: "select",
      options: paymentAccounts.options,
      defaultValue: paymentAccounts.options?.[0]?.value,
      blur: true,
      className: "col-6",
    },
  ];
};

const tabButtons = [
  { label: <p>Scheduled Loans</p>, title: "Scheduled Loans", key: 1 },
  { label: <p>Non scheduled Loans</p>, title: "Non scheduled Loans", key: 0 },
];

function getNextValidDate(selectedDay) {
  const today = new Date();
  const currentDay = today.getDate();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed

  const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();

  // If valid and still upcoming this month
  if (selectedDay > currentDay && selectedDay <= daysInCurrentMonth) {
    return new Date(year, month, selectedDay);
  }

  // Else, return the same day next month
  const nextMonth = (month + 1) % 12;
  const nextYear = month === 11 ? year + 1 : year;
  const daysInNextMonth = new Date(nextYear, nextMonth + 1, 0).getDate();

  // Adjust selectedDay if it exceeds next month's max day (e.g. Feb 30)
  const adjustedDay = Math.min(selectedDay, daysInNextMonth);

  return new Date(nextYear, nextMonth, adjustedDay);
}

const ActionComp = ({
  defaultVal,
  key1,
  loan,
  singleAccount,
  setRefresh,
  refresh,
  disabled,
  noBankAssociated,
}) => {
  const [radioValue, setRadioValue] = useState(defaultVal);
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  
  const loanId = singleAccount ? selectedAccount?.value : loan?.recid;

  function handleOnClick(e) {
    setRadioValue(e.currentTarget.value);
    if (defaultVal !== e.currentTarget.value) {
      setShowAlert(true);
    }
  }

  async function onSubmit() {
    setLoading(true);

    const id = toast.loading("Processing your request...");

    try {
      const data = {
        recid: singleAccount ? selectedAccount?.value : loan?.recid,
        status: defaultVal === "Active" ? "0" : "1",
      };

      const payloadForSql = {
        ...data,
        email:
          masqueradeEmail?.isIt == true
            ? masqueradeEmail?.p_logged_in_email
            : email,
      };
      const res = await axios.post(
        urls.borrower.updateStatus,
        data,
        oracleConfig,
      );

      if (res.status == "200") {
        const res2 = await axios.post(
          urls.borrower.updateStatusTMO,
          payloadForSql,
        );

        if (res2.status == "200") {
          toast.update(id, {
            render: `${
              loan?.account ? loan?.account : selectedAccount?.label
            } has been ${
              defaultVal === "Active"
                ? "deactivated successfully from autopay!"
                : "activated successfully for autopay!"
            }`,
            type: "success",
            isLoading: false,
            ...commonToast,
          });
          setRefresh((refresh) => !refresh);
          setLoading(false);
          setShowAlert(false);
        }
      }
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "Some error occured!",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
      setLoading(false);
      setShowAlert(false);
      setRadioValue(defaultVal);
    }
  }

  function handleClose() {
    setShowAlert(false);
    setRadioValue(defaultVal);
  }

  return (
    <>
      <div className={styles.actionWrapper}>
        {/* Dynamic Tooltip */}
        {hoveredRow === loanId && !noBankAssociated && (
          <div className={`${styles.customTooltip}`}>
            {defaultVal === "Active"
              ? "Pause recurring ACH"
              : "Enable recurring ACH"}
          </div>
        )}

        {hoveredRow === loanId && noBankAssociated && (
          <div className={`${styles.customTooltip}`}>
            No bank account is associated with this loan. Select the checkbox to
            set up a bank account.
          </div>
        )}

        <button
          onMouseEnter={() => setHoveredRow(loanId)}
          onMouseLeave={() => setHoveredRow(null)}
          onClick={() => {
            if (!noBankAssociated) {
              setShowAlert(true);
            }
          }}
          // disabled={defaultVal !== "Active" ? disabled : false}
          style={
            defaultVal !== "Active" && disabled
              ? { cursor: "not-allowed" }
              : null
          }
          className={`${defaultVal === "Active" ? styles.btnDeactivate : styles.btnActivate} small`}
        >
          {defaultVal === "Active" ? (
            <>
              <BsSlashCircle className="me-2" /> Deactivate
            </>
          ) : (
            <>
              <BsCheckCircle className="me-2" /> Activate
            </>
          )}
        </button>
      </div>
      {/* <ComingSoonWrapper
        show={defaultVal === "Inactive"}
        label={"Active"}
        tooltip={
          "Click here to activate this loan account for monthly recurring payments."
        }
      >
        <ToggleButton
          key={key1 + "Active"}
          id={`radio-${key1 + "Active"}`}
          type="radio"
          variant={radioValue === "Active" ? "success" : "outline-success"}
          name="radio"
          value={"Active"}
          checked={radioValue === "Active"}
          onChange={(e) => handleOnClick(e)}
          disabled={disabled}
        >
          Active
        </ToggleButton>
      </ComingSoonWrapper>

      <ComingSoonWrapper
        show={defaultVal === "Active"}
        label={"Inactive"}
        tooltip={
          "Click here to deactivate this loan account from monthly recurring payments."
        }
      >
        <ToggleButton
          key={key1 + "Inactive"}
          id={`radio-${key1 + "Inactive"}`}
          type="radio"
          variant={radioValue === "Inactive" ? "error" : "outline-error"}
          name="radio"
          value={"Inactive"}
          checked={radioValue === "Inactive"}
          onChange={(e) => handleOnClick(e)}
          disabled={disabled}
        >
          Inactive
        </ToggleButton>
      </ComingSoonWrapper> */}

      <PopupWrapper
        size="s"
        title={
          <div className="d-flex align-items-center">
            <BsXCircle className="text-error me-3" size={28} />
            <h5 className="fw-bold mb-0">
              {defaultVal === "Active"
                ? "Deactivate recurring ACH?"
                : "Activate Recurring ACH?"}
            </h5>
          </div>
        }
        extraClass="kmw-20"
        backdrop="static"
        headerClassName="pt-5 px-5 border-0"
        Component={
          // <div>
          //   <p className="fw-bold text-center">
          //     Are you sure you want to{" "}
          //     {defaultVal === "Active" ? "deactivate" : "activate"} your monthly
          //     AutoPay?
          //   </p>
          //   <div className="d-flex justify-content-end gap-5 mb-3">
          //     <LoadingButton
          //       loading={loading}
          //       disabled={loading}
          //       type="submit"
          //       className="btn btn-primary text-white"
          //       title={"Yes"}
          //       onClick={onSubmit}
          //     />
          //     <button className="btn btn-primary" onClick={handleClose}>
          //       No
          //     </button>
          //   </div>
          // </div>
          <div className="d-flex flex-column justify-content-between align-items-start mb-3">
            {defaultVal === "Active" ? (
              <p className="text-secondary mb-4 ms-5">
                Loan <strong className="text-dark">{key1}</strong> will no
                longer be debited until you reactivate it. By submitting this
                request, you are canceling your existing recurring ACH payment.
                Please note that your loan agreement requires you to maintain an
                active automatic payment method. Canceling your current ACH does
                not waive or pause your payment obligations. You are required to
                either: • Establish a new recurring ACH payment, or • Provide an
                alternative approved payment method immediately Failure to
                maintain an active payment method may result in missed or late
                payments, additional fees, and potential default under the terms
                of your loan. If you are updating your bank information, please
                set up your new recurring ACH without delay to avoid any
                disruption in your scheduled payments. If you have questions or
                need assistance, please contact Customer Service before
                submitting this request.
              </p>
            ) : (
              <p className="text-secondary mb-4 ms-5">
                Loan <strong className="text-dark">{key1}</strong> will be
                debited monthly starting the next scheduled date.
              </p>
            )}

            <div className="d-flex justify-content-end gap-3 w-100">
              <button
                // variant="link"
                className="text-black btn btn-outline-grey fw-bold"
                onClick={handleClose}
              >
                Cancel
              </button>
              <LoadingButton
                loading={loading}
                disabled={loading}
                type="submit"
                className={`btn ${defaultVal === "Active" ? "btn-error" : "btn-primary"} text-white`}
                title={defaultVal === "Active" ? "Deactivate" : "Activate"}
                onClick={onSubmit}
              />
            </div>
          </div>
        }
        toShow={showAlert}
        closeEventHandler={handleClose}
        centered={true}
      />
    </>
  );
};

const UpdateLoansModal = ({
  show,
  onHide,
  selectedLoans,
  loanOptionValue,
  paymentAccounts,
  nextValidDate,
  register,
  watch,
  setValue,
  errors,
  SubmitButton,
  errorCode,
  laonStatus,
}) => {
  const authorized = watch("authorization");
  const navigate = useNavigate();

  return (
    <PopupWrapper
      // size="s"
      title={
        <h2 className={styles.modalTitle}>
          Update {selectedLoans?.length} selected loan(s)
        </h2>
      }
      extraClass="kmw-70"
      backdrop="static"
      headerClassName="pt-5 px-5 border-0"
      Component={
        <div className="p-2">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div>
              <p className={styles.modalDescription}>
                Submitting will also enable autopay for the selected loans.
              </p>
            </div>
          </div>

          {/* Status Alert */}
          {laonStatus === "Inactive" && (
            <div className={styles.alertBox}>
              <BsCheckCircle className="text-danger" />
              <span>
                Selected {selectedLoans?.length} loans are currently inactive
                and will be activated for autopay on submit.
              </span>
            </div>
          )}

          {/* Applying To Section */}
          <div className={styles.applyingToSection}>
            <div className={styles.sectionLabel}>Applying to</div>
            <div className="d-flex flex-wrap gap-2">
              {selectedLoans.map((el, idx) => (
                <span key={idx} className={styles.loanChip}>
                  {el?.loan_account?.split(" - ")?.[0]}
                </span>
              ))}
            </div>
          </div>

          <div className="mb-5">
            {/* <Form.Label className="mt-5 fw-bold">Permanency</Form.Label> */}
            <div className="row">
              <FormBox
                options={optionsArr(
                  loanOptionValue,
                  paymentAccounts,
                  nextValidDate,
                )}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
            </div>
            <div className="text-decoration-none text-primary pe-5 d-flex align-items-center justify-content-end mb-5">
              <div
                className="d-flex align-items-center gap-3"
                role="button"
                onClick={() => navigate("/add-bank-account")}
              >
                <div>
                  <PlusCircleFill style={{ color: "var(--primary-color)" }} />
                </div>
                <div>Add New Bank Account</div>
              </div>
            </div>
          </div>

          {/* Authorization Checkbox */}
          <div
            className={`${styles.authBox} ${authorized ? styles.authBoxActive : ""}`}
            onClick={() => {
              setValue("authorization", !authorized);
            }}
          >
            <div className={`form-check p-0 m-0`}>
              <input
                type="checkbox"
                className="form-check-input rounded-circle border-secondary border-2"
                style={{ width: "24px", height: "24px", float: "none" }}
                checked={authorized}
                {...register("authorization", {
                  required: "**Authorization must be true",
                })}
                onChange={() => {}}
              />
            </div>
            <span className="small fw-500">
              I hereby authorize Superior Loan Servicing to debit my account. If
              the above noted payment dates fall on a weekend or holiday, I
              understand that the payments may be executed on the next business
              day. I understand that recurring monthly payments will be debited
              for the amount billed each month or the payment due each month
              including any unpaid charges and/or late charges. For ACH debits
              from my checking/savings account, I understand that because these
              are electronic transactions, these funds may be withdrawn from my
              account as soon as the date entered above. In the case of an ACH
              Transaction being rejected for Non-Sufficient Funds (NSF) I
              understand that Superior Loan Servicing may at its discretion
              attempt to process the charge again within 30 days, and agree to
              an additional $45 charge for each attempt returned NSF which will
              be initiated as a separate transaction from the authorized
              recurring payment. I acknowledge that the origination of ACH
              transactions from my account must comply with the provisions of
              U.S. law. I certify that I am an authorized user of this bank
              account and will not dispute these scheduled transactions with my
              bank; so long as the transactions correspond to the terms
              indicated in this authorization. All ACH payments post on the next
              business day following the date they are scheduled. All payments
              are considered received on the date of posting and not the date
              they are scheduled. Payments that are scheduled on the last day of
              a grace period will not post until the following business day and
              the account may be subject to a late charge.
            </span>
          </div>
          <div
            className="invalid-feedback text-center"
            style={{ display: "block" }}
          >
            {errors?.authorization?.message}
          </div>
          {errorCode}

          {/* Footer Actions */}
          <div className="d-flex justify-content-end align-items-center mt-5 gap-4">
            <button
              // variant="link"
              className="text-black btn btn-outline-grey fw-bold"
              onClick={onHide}
            >
              Cancel
            </button>
            {SubmitButton}
          </div>
        </div>
      }
      toShow={show}
      closeEventHandler={onHide}
      centered={true}
    />
  );
};
